const initTop = () => {
  window.addEventListener('load', () => {
    slideGallery();
    scrollScaleImg();
    transformHeader();
    changeMaskImg();
    parallaxImg();
    // scrollLenis();
    togglePlayVideo();
    toggleCV();
    if (mediaQuery.matches) {
      drawerUI();
    }
  });
  functionUI();
  accordionUI();
};
const mediaQuery = window.matchMedia('(max-width: 768px)');

// パララックス効果
const parallaxImg = () => {
  const parallaxTargets = document.querySelectorAll('[data-parallax]');
  if (!parallaxTargets.length) return;
  // @ts-ignore
  gsap.registerPlugin(ScrollTrigger);
  parallaxTargets.forEach(target => {
    const ratio = parseFloat(target.getAttribute('data-parallax') || '0.1');
    // @ts-ignore
    gsap.to(target, {
      y: () => (window.innerHeight * ratio),
      ease: 'none',
      scrollTrigger: {
        trigger: target,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      }
    });
  });
};

const scrollLenis = () => {
  // @ts-ignore
  const lenis = new Lenis({
    autoRaf: true,
  });
};

const functionUI = () => {
  const btns = document.querySelectorAll('[data-function-btn');
  const bgImgs = document.querySelectorAll('[data-function-bg');

  // @ts-ignore
  function setBtnState(clickedBtn) {
    const isAlreadyOpen = clickedBtn.classList.contains('is_open');
    const openBtn = Array.from(btns).find(b => b.classList.contains('is_open'));

    let activeIdx = -1;
    btns.forEach((b, idx) => {
      if (b === clickedBtn) activeIdx = idx;
    });

    if (isAlreadyOpen) {
      btns.forEach(b => {
        b.classList.remove('is_open', 'is_close');
      });
      bgImgs.forEach((bg, idx) => {
        bg.classList.remove('is_active');
        if (idx === activeIdx) {
          bg.classList.add('is_visible');
        } else {
          bg.classList.remove('is_visible');
        }
      });
      return;
    }

    const btnId = clickedBtn.id;
    if (openBtn) {
      btns.forEach((b, idx) => {
        if (b === clickedBtn) {
          b.classList.add('is_open');
          b.classList.remove('is_close');
          activeIdx = idx;
        } else {
          b.classList.remove('is_open');
          b.classList.add('is_close');
        }
      });
      bgImgs.forEach((bg, idx) => {
        if (idx === activeIdx) {
          bg.classList.add('is_active');
        } else {
          bg.classList.remove('is_active');
        }
      });
      bgImgs.forEach((bg, idx) => {
        if (bg.classList.contains('is_active')) {
          bg.classList.add('is_visible');
        } else {
          bg.classList.remove('is_visible');
        }
      });
      // is_openになる時だけ一度だけスクロール
      if (btnId) {
        gsap.to(window, { duration: 0, scrollTo: { y: `#${btnId}`, offsetY: 60 }, delay: 0.6 });
      }
      return;
    }

    btns.forEach((b, idx) => {
      if (b === clickedBtn) {
        b.classList.add('is_open');
        b.classList.remove('is_close');
        activeIdx = idx;
      } else {
        b.classList.remove('is_open');
        b.classList.add('is_close');
      }
    });
    bgImgs.forEach((bg, idx) => {
      if (idx === activeIdx) {
        bg.classList.add('is_active');
      } else {
        bg.classList.remove('is_active');
      }
    });
    bgImgs.forEach((bg, idx) => {
      if (bg.classList.contains('is_active')) {
        bg.classList.add('is_visible');
      } else {
        bg.classList.remove('is_visible');
      }
    });
    if (btnId) {
      gsap.to(window, { duration: 0, scrollTo: { y: `#${btnId}`, offsetY: 60 }, delay: 0.6 });
    }
  }

  btns.forEach(btn => {
    btn.addEventListener('click', () => setBtnState(btn));
    btn.addEventListener('mouseover', () => {
      if (btn.classList.contains('is_close')) return;
      let idx = -1;
      btns.forEach((b, i) => {
        if (b === btn) idx = i;
      });
      bgImgs.forEach(bg => bg.classList.remove('is_visible'));
      if (idx > -1 && bgImgs[idx]) {
        // @ts-ignore
        bgImgs[idx].classList.add('is_visible');
      }
    });
  });
};

const accordionUI = () => {
  // @ts-ignore
  gsap.registerPlugin(ScrollToPlugin);

  const accordionBtns = document.querySelectorAll('[data-accordion-btn]');

  accordionBtns.forEach((accordionBtn, btnIdx) => {
    accordionBtn.addEventListener('click', () => {
      const accordionId = accordionBtn.getAttribute('aria-controls');
      if (!accordionId) return;
      const accordionPanel = document.getElementById(accordionId);
      const isOpen = accordionBtn.getAttribute('aria-expanded') === 'true';
      const nextOpen = !isOpen;
      const detailImgs = document.querySelectorAll('[data-detail-img]');

      accordionBtns.forEach((btn) => {
        const id = btn.getAttribute('aria-controls');
        if (!id) return;
        const panel = document.getElementById(id);
        btn.setAttribute('aria-expanded', 'false');
        if (panel) {
          panel.setAttribute('aria-hidden', 'true');
          // @ts-ignore
          gsap.to(panel, {
            height: 0,
            ease: 'power2.inOut',
            duration: 0.4,
          });
        }
      });
      if (nextOpen) {
        detailImgs.forEach(img => img.classList.remove('is_active'));

        accordionBtn.setAttribute('aria-expanded', 'true');
        if (accordionPanel) {
          accordionPanel.setAttribute('aria-hidden', 'false');
          // @ts-ignore
          gsap.to(accordionPanel, {
            height: 'auto',
            ease: 'power2.inOut',
            duration: 0.4,
            onStart: () => {
              if (mediaQuery.matches) {
                const btnId = accordionBtn.id;

                if (btnId) {
                  const anchorEl = document.getElementById(btnId);
                  console.log(anchorEl);
                  if (anchorEl) {
                    // @ts-ignore
                    gsap.to(window, { duration: 0, scrollTo: { y: anchorEl, offsetY: 60 }, delay: 0.3 });
                  }
                }
              }
            }
          });
        }
        if (detailImgs[btnIdx]) {
          detailImgs[btnIdx].classList.add('is_active');
        }
      }
    });
  });
};

const slideGallery = () => {
  // @ts-ignore
  const swiper = new Swiper('[data-swiper]', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    speed: 600,
    breakpoints: {
      768: {
        spaceBetween: 24,
      },
    },
    navigation: {
      nextEl: '.un_gallery_btn__next',
      prevEl: '.un_gallery_btn__prev',
    },
  });
};

const scrollScaleImg = () => {
  const scaleTarget = document.querySelector('[data-scale-target]');
  const scaleTrigger = document.querySelector('[data-scale-trigger]');
  if (!scaleTarget || !scaleTrigger) return;
  const imgs = scaleTarget.querySelectorAll('img');
  if (!imgs.length) return;
  const imgCount = imgs.length;

  // @ts-ignore
  gsap.registerPlugin(ScrollTrigger);

  // scaleアニメーション（既存）
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  // @ts-ignore
  const targetWidth = scaleTarget.offsetWidth;
  // @ts-ignore
  const targetHeight = scaleTarget.offsetHeight;

  const scaleVal = Math.max(windowWidth / targetWidth, windowHeight / targetHeight);
  // @ts-ignore
  gsap.to(scaleTarget, {
    scale: scaleVal,
    scrollTrigger: {
      trigger: scaleTrigger,
      start: 'top bottom',
      end: 'bottom bottom',
      scrub: true,
    }
  });

  // @ts-ignore
  ScrollTrigger.create({
    trigger: scaleTrigger,
    start: 'top center',
    toggleClass: {
      targets: scaleTarget,
      className: 'is_index',
    },
  });

  // 画像切り替えアニメーション
  imgs.forEach((img, i) => {
    if (i === 0) {
      // @ts-ignore
      img.style.opacity = 1;
      // @ts-ignore
      img.style.zIndex = 2;
    } else {
      // @ts-ignore
      img.style.opacity = 0;
      // @ts-ignore
      img.style.zIndex = 1;
    }
  });

  // @ts-ignore
  ScrollTrigger.create({
    trigger: scaleTrigger,
    start: 'top bottom',
    end: 'bottom bottom',
    scrub: true,
    // @ts-ignore
    onUpdate: (self) => {
      const progress = self.progress; // 0〜1
      const idx = Math.min(Math.floor(progress * imgCount), imgCount - 1);
      imgs.forEach((img, i) => {
        if (i === idx) {
          // @ts-ignore
          gsap.to(img, { autoAlpha: 1, duration: 0.8, overwrite: true, ease: 'power1.out' });
          // @ts-ignore
          img.style.zIndex = 2;
        } else {
          // @ts-ignore
          gsap.to(img, { autoAlpha: 0, duration: 0.8, overwrite: true, ease: 'power1.out' });
          // @ts-ignore
          img.style.zIndex = 1;
        }
      });
    }
  });
};

const drawerUI = () => {
  const drawerBtns = document.querySelectorAll('[data-drawer-btn]');
  const drawerCloseBtns = document.querySelectorAll('[data-drawer-close-btn]');
  const drawerList = document.querySelector('[data-drawer-list]');
  const html = document.querySelector('html');
  const scrollbarWidth = window.innerWidth - document.body.clientWidth;
  const inertTargets = document.querySelectorAll('[data-inert]');
  let isOpen = false;

  // @ts-ignore
  const _switchModal = (btn, boolean) => {
    const modalId = btn.getAttribute('aria-controls');
    if (!modalId) return;
    const modalCont = document.getElementById(modalId);
    isOpen = boolean === true ? false : true;
    const alphaVal = isOpen === true ? 1 : 0;
    const blurVal = isOpen === true ? '6px' : '0';
    const overflowVal = isOpen === true ? 'hidden' : '';
    const paddingVal = isOpen && scrollbarWidth > 0 === true ? scrollbarWidth + 'px' : '';

    btn.setAttribute('aria-expanded', (!boolean).toString());
    // @ts-ignore
    modalCont.setAttribute('aria-hidden', boolean.toString());
    // @ts-ignore
    gsap.to(modalCont, { autoAlpha: alphaVal, ease: 'power1.out', duration: 0.4 });
    // @ts-ignore
    html.style.overflow = overflowVal;
    // @ts-ignore
    html.style.paddingRight = paddingVal;
    // @ts-ignore
    drawerList.style.setProperty('--blur-val', blurVal);

    // 背面のフォーカスを制御
    inertTargets.forEach((target) => {
      // @ts-ignore
      target.inert = isOpen;
    });
  };

  // 指定した要素以外のスクロールを抑制
  // @ts-ignore
  const _scrollLock = (event) => {
    if (event.touches && event.touches.length > 1) return;

    // @ts-ignore
    const isScrollable = (element) => element.clientHeight < element.scrollHeight;
    const scrollElement = event.target.closest('[data-scrollable]');

    if (scrollElement === null) {
      event.preventDefault();
      return;
    }
    if (scrollElement && isScrollable(scrollElement)) {
      event.stopPropagation();
    } else {
      event.preventDefault();
    }
  };

  drawerBtns.forEach((drawerBtn) => {
    drawerBtn.addEventListener('click', () => {
      if (!isOpen) {
        document.addEventListener('touchmove', _scrollLock, { passive: false });
      } else {
        document.removeEventListener('touchmove', _scrollLock);
      }
      _switchModal(drawerBtn, isOpen);
    });
  });

  drawerCloseBtns.forEach((drawerCloseBtn) => {
    drawerCloseBtn.addEventListener('click', () => {
      const modalId = drawerCloseBtn.getAttribute('aria-controls');
      const targetModalBtn = document.querySelector('[data-drawer-btn][aria-controls="' + modalId + '"]');
      _switchModal(targetModalBtn, true);
      document.removeEventListener('touchmove', _scrollLock);
    });
  });
};

const transformHeader = () => {
  const header = document.querySelector('[data-header]');
  const contents = document.querySelector('[data-contents]');
  if (!header) return;

  // @ts-ignore
  gsap.registerPlugin(ScrollTrigger);
  let lastScroll = window.scrollY;

  // @ts-ignore
  ScrollTrigger.create({
    trigger: contents,
    start: 'top top',
    toggleClass: {
      targets: header,
      className: 'is_bg',
    },
  });

  // @ts-ignore
  ScrollTrigger.create({
    start: 0,
    end: 'max',
    // @ts-ignore
    onUpdate: (self) => {
      const currentScroll = window.scrollY;
      if (currentScroll > lastScroll && currentScroll > 0) {
        // @ts-ignore
        gsap.to(header, { y: '-100%', duration: 0.5, ease: 'power2.out' });
      } else {
        // @ts-ignore
        gsap.to(header, { y: '0%', duration: 0.5, ease: 'power2.out' });
      }
      lastScroll = currentScroll;
    },
  });
};

const toggleCV = () => {
  const cv = document.querySelector('.js_cv');
  if (!cv) return;
  // @ts-ignore
  gsap.to(cv, {
    autoAlpha: 1,
    duration: 0.5,
    ease: 'power1.out',
    scrollTrigger: {
      trigger: '.un_intro',
      endTrigger: '.bl_footer',
      start: 'top top',
      end: 'top bottom',
      toggleActions: 'play reverse play reverse',
    }
  });
}

const changeMaskImg = () => {
  const containers = document.querySelectorAll('[data-change-img]');
  const trigger = document.querySelector('[data-change-trigger]');
  if (!containers.length || !trigger) return;
  // @ts-ignore
  gsap.registerPlugin(ScrollTrigger);

  containers.forEach(container => {
    const pictures = container.querySelectorAll('picture');
    if (!pictures.length) return;
    const delay = 0.25;

    // @ts-ignore
    ScrollTrigger.create({
      trigger: trigger,
      start: 'top bottom',
      end: 'bottom bottom',
      scrub: true,
      // @ts-ignore
      onUpdate: (self) => {
        const progress = self.progress;
        const count = pictures.length;
        const seg = 1 / count;
        for (let n = count - 1; n >= 0; n--) {
          const pic = pictures[n];
          if (n === 0) {
            // @ts-ignore
            pic.style.clipPath = 'inset(0 0 0 0)';
            continue;
          }
          const i = count - 1 - n;
          const delayOffset = i * delay;
          const start = seg * i + delayOffset;
          const end = seg * (i + 1) + delayOffset;
          let localProgress = (progress - start) / seg;
          localProgress = Math.max(0, Math.min(1, localProgress));
          if (progress >= end) {
            // @ts-ignore
            pic.style.clipPath = 'inset(0 0 100% 0)';
          } else if (progress <= start) {
            // @ts-ignore
            pic.style.clipPath = 'inset(0 0 0 0)';
          } else {
            // @ts-ignore
            pic.style.clipPath = `inset(0 0 ${localProgress * 100}% 0)`;
          }
        }
      }
    });
  });
};

const togglePlayVideo = () => {
  const videos = document.querySelectorAll('[data-video]');
  const contents = document.querySelector('[data-contents]');
  if (!videos.length) return;

  // @ts-ignore
  gsap.registerPlugin(ScrollTrigger);

  // @ts-ignore
  ScrollTrigger.create({
    trigger: contents,
    start: 'top top',
    onEnter: () => {
      videos.forEach(video => {
        if (video instanceof HTMLVideoElement) {
          video.pause();
        }
      });
    },
    onLeaveBack: () => {
      videos.forEach(video => {
        if (video instanceof HTMLVideoElement) {
          video.play();
        }
      });
    }
  });
};

initTop();